<!--表单页面拷贝开始-->
<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="标题">
          <el-col :span="8">
            <el-input v-model="sysTestReport.title"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="类型">
          <el-col :span="8">
            <el-select v-model="sysTestReport.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="内容">
          <el-col :span="24">
            <!-- <el-input v-model="sysTestReport.content" ></el-input> -->
            <mavon-editor class="mavonEditor" v-model="sysTestReport.content" @imgAdd="imgAdd" @imgDel="imgDel" ref="editor"></mavon-editor>
          </el-col>
        </el-form-item>
        
      </template>
    </form-components>
  </div>
</template>
  <style>
.mavonEditor {
  height: 600px;
}
</style>
  <script>
import FormComponents from "@/components/form/FormComponents";
import SysTestReportApi from "@/api/SysTestReportApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
export default {
  name: "SaveSysTestReportPage",
  props: {
    msg: String,
  },
  components: {
    FormComponents,
    mavonEditor,
  },
  data() {
    return {
      sysTestReport: {
        title: "",
        content: "",
        type: "",
      },
      options:[
        {
          value:"press",
          label:"压力测试报告"
        },
        {
          value:"ui",
          label:"UI测试报告"
        }
      ]
    };
  },
  created() {
    this.sysTestReport = this.$route.params;
  },
  methods: {
    submitForm() {
      this.sysTestReport.id > 0
        ? this.updateSysTestReportById()
        : this.addSysTestReport();
    },
    addSysTestReport() {
      SysTestReportApi.saveSysTestReport(this.sysTestReport).then((resp) => {
        if (resp.state == "OK") {
          this.sysTestReport = {};
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    updateSysTestReportById() {
      SysTestReportApi.updateSysTestReport(this.sysTestReport).then((resp) => {
        if (resp.state == "OK") {
          this.user = {};
          this.$successMsg(resp.msg);
          navTo(this, "/sysTestReportList");
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    imgAdd(filename,file){
      SysTestReportApi.uploadTestReportPic(file).then((resp)=>{
        console.log(resp.data)
        this.$refs.editor.$img2Url(filename, resp.data);
      })
    },
    imgDel(filename){
      console.log(filename);
    }
  },
};
</script>
  
  
  <!--表单页面拷贝结束-->